import { create } from "zustand";
import { CartResponse } from "../types";
import { URL } from "../../lib/apis";

interface CartState {
  cartDetails: any; // Initialise à null pour éviter les erreurs au chargement
  loadingCat: boolean;
  fetchAllCat: () => Promise<void>;
}

const useCartDetail = create<CartState>((set) => ({
  cartDetails: null, // Initialise à null avant le chargement des données
  loadingCat: false,
  

  fetchAllCat: async () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user");

    if (!token) {
      console.error("User is not authenticated");
      return;
    }

    set({ loadingCat: true });

    try {
      const response = await fetch(
        `${URL}/cart-details/users/${userId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch categories: ${response.statusText}`);
      }

      const data = await response.json();
      set({ cartDetails: data, loadingCat: false }); // On assigne directement 'data' sans 'data.data'
    } catch (error) {
      if (error instanceof Error) {
        set({ cartDetails: [], loadingCat: false });
        console.error("Error fetching categories:", error.message);
      } else {
        set({ cartDetails: [], loadingCat: false });
        console.error("Unknown error occurred");
      }
      set({ loadingCat: false });
    }finally{
      set({ loadingCat: false });
    }
  },
}));

export default useCartDetail;
